import { type PlaidLinkToken } from '~shared/types';

export const CREATE_PLAID_LINK_TOKEN_SUCCEEDED = 'CREATE_PLAID_LINK_TOKEN_SUCCEEDED';
export type CreatePlaidLinkTokenSucceedAction = {
  type: typeof CREATE_PLAID_LINK_TOKEN_SUCCEEDED;
  payload: PlaidLinkToken;
};
export const createPlaidLinkTokenSucceeded = (plaidLinkToken: PlaidLinkToken): CreatePlaidLinkTokenSucceedAction => ({
  type: CREATE_PLAID_LINK_TOKEN_SUCCEEDED,
  payload: plaidLinkToken,
});
